
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSystem as ObiSystemElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-system.js';
 
 
 

 
 export const ObiSystem = createComponent({
   react: React,
   tagName: 'obi-system',
   elementClass: ObiSystemElement,
   events: {
     
   }
  });
 
 